import React from 'react';
import HomePage from './HomePage';
import './style.css';

function App() {
  return (
    <div className="app">
      <HomePage />
    </div>
  );
}

export default App;
